// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","header":"header-1xA9Y","miles":"miles-3xlWH","miles_currency":"miles_currency-1kofL","menu":"menu-2941E"};